const anselConfig = Object.freeze({
    LABEL: 'Ansel',
    SHORT_LABEL: 'Ansel',
    NAME: 'ansel',
    URL_BASE: 'https://joinansel.com',
    PALETTE: {
        PRIMARY: '#214E41',
        SECONDARY: '#43806C',
    },
    CONTACT_SUPPORT: {
        EMAIL: 'support@joinansel.com',
        NUMBER: '(888) 300-5382',
        WEB_SITE: 'https://www.joinansel.com'
    },
    S3: {
        BASE_URL: 'https://joinansel-platform-assets.s3.amazonaws.com',
        SP_NAME: 'ansel',
        APPLICATION: 'enrollment',
    },
    LEGAL:{
        SERVICE_NAME: 'Ansel Services, Inc.',
        INSURANCE_NAME: 'Ansel Health, Inc.',
        TERMS: 'https://www.joinansel.com/terms',
        PRIVACY: 'https://www.joinansel.com/privacy-policy'
    },
});

export default anselConfig;